import React, { useState, useEffect } from "react";
import Button from "react-bootstrap/Button";
import pdf from "../../Assets/../Assets/MY-SAMPLE-cv.pdf";
import { AiOutlineDownload } from "react-icons/ai";
import pdf2 from "../../Assets/../Assets/certificate.pdf";


function ResumeNew() {
  const [width, setWidth] = useState(1200);

  useEffect(() => {
    setWidth(window.innerWidth);
  }, []);

  return (
    <div className="resume" >
      <Button
        variant="primary"
        href={pdf}
        target="_blank"
        style={{ maxWidth: "250px" }}
      >
        <AiOutlineDownload />
        &nbsp;View / Download CV
      </Button>

      &nbsp;&nbsp;&nbsp;&nbsp;

       <Button
        variant="primary"
        href={pdf2}
        target="_blank"
        style={{ maxWidth: "250px", right:"100px" }}
      >
        <AiOutlineDownload />
        &nbsp;Google Marketing&nbsp; Certificate
      </Button>


    </div>

    
     
 
  );
}

export default ResumeNew;
